module.exports = __webpack_public_path__ + "static/img/xc5.43bd1bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xc5.jpg
// module id = 0zqz
// module chunks = 0